<div class="wrapper">
  @if (!emailSent) {
  <p-card class="email-form-card">
    <h1>Forgot Password</h1>

    <h3>Enter your email:</h3>
    <emr-input type="text" [control]="email" />
    @if (invalidEmail) {
    <div class="error-msg">Invalid email!</div>
    }
    @if (noEmailExists) {
    <div class="error-msg">No account associated with this email.</div>
    }
    <div class="submit-btn-container">
      <button pButton pRipple type="button" (click)="onSubmit()">Send Password Reset Email</button>
    </div>
  </p-card>

  } @else {

  <p-card class="text-card">
    <h3>Email sent!</h3>
    <p>A password reset link was sent to your email!</p>
    <p>Click the link in the email to create a new password.</p>
    <p>
      Make sure to check your spam folder for the password reset email. If you do not receive an
      email within 5 minutes, please click the re-send email link below.
    </p>

    <span class="link" (click)="sendEmail()">Re-send Email</span>
  </p-card>
  }
</div>